import { PRICE_CHANGE } from '../../constants'

const priceChange = (fieldName, value, dispatch) => {
  const [, id] = fieldName.split('_')
  dispatch({ type: PRICE_CHANGE, id, value })
}

export default (fieldName, value) => dispatch => priceChange(fieldName, value, dispatch)
